export default "__VITE_ASSET__CF1F2Qge__"